import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';

import GAS from "../../../GAS";
import "./styles.css";

const HomePainel = ({ painel, usuario, setDialogCompartilhar, setPainel, showMessage}) => {
    const history = useHistory();

    const titulo =  (
        <div>
            <i className="pi pi-star" /> {painel.nivelOrganizacional['CAMPUS']}
            <br />
            <i className="pi pi-sitemap" /> {painel.nivelOrganizacional['CURSO']}
        </div>
    );

    return (
        <Card className="respondido" id='painel-apropriador'
              key={painel.proprietario}
              title={titulo}
              subTitle={`PAINEL DISPONÍVEL ATÉ ${new Date(painel.terminoAplicacao).toLocaleString()}`}
        >
            <div>
                {usuario.email === painel.proprietario &&
                <Button
                    label="COMPARTILHAR"
                    icon="pi pi-users"
                    onClick={() => setDialogCompartilhar(true)}
                    style={{ marginRight: '10px', bottom: 5 }}
                />}
            
            </div>
        </Card>
    );
};

export default HomePainel;
